import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import de from './locales/de.json';
import nl from './locales/nl.json';
import sv from './locales/sv.json';
import da from './locales/da.json';
import no from './locales/no.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import ca from './locales/ca.json';
import cs from './locales/cs.json';
import hr from './locales/hr.json';
import pl from './locales/pl.json';
import ru from './locales/ru.json';
import sk from './locales/sk.json';
import sl from './locales/sl.json';
import zh from './locales/zh.json';
import zhTW from './locales/zh-TW.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import th from './locales/th.json';
import hi from './locales/hi.json';
import af from './locales/af.json';
import et from './locales/et.json';
import fi from './locales/fi.json';
import el from './locales/el.json';
import he from './locales/he.json';
import hu from './locales/hu.json';
import lv from './locales/lv.json';
import lt from './locales/lt.json';
import tr from './locales/tr.json';
import zu from './locales/zu.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  ar: { translation: ar },
  de: { translation: de },
  nl: { translation: nl },
  sv: { translation: sv },
  da: { translation: da },
  no: { translation: no },
  it: { translation: it },
  pt: { translation: pt },
  ca: { translation: ca },
  cs: { translation: cs },
  hr: { translation: hr },
  pl: { translation: pl },
  ru: { translation: ru },
  sk: { translation: sk },
  sl: { translation: sl },
  zh: { translation: zh },
  'zh-TW': { translation: zhTW },
  ja: { translation: ja },
  ko: { translation: ko },
  th: { translation: th },
  hi: { translation: hi },
  af: { translation: af },
  et: { translation: et },
  fi: { translation: fi },
  el: { translation: el },
  he: { translation: he },
  hu: { translation: hu },
  lv: { translation: lv },
  lt: { translation: lt },
  tr: { translation: tr },
  zu: { translation: zu },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'language',
      lookupLocalStorage: 'cardview-language',
      caches: ['localStorage'],
    },
  });

export default i18n;